import { SpaceUserDocument, SpaceUserRole } from "popopo-msg"
import React, { useEffect } from "react"
import { useForm } from "react-hook-form"
import { User } from "firebase/auth"
import { api } from "../../core"
import { useToast } from "popopo-lib-front/hook"

type SpaceRoleSwitchForms = {
  role: SpaceUserRole
}

export const SpaceRoleNormalSwitchButton = (props: { firebase: User; spaceUser: SpaceUserDocument }) => {
  const {setValue, watch, handleSubmit, formState, register} = useForm<SpaceRoleSwitchForms>({
    mode: "onBlur",
    defaultValues: {
      role: props.spaceUser.role,
    },
  })
  const toast = useToast()
  useEffect(() => {
    setValue('role', props.spaceUser.role)
  }, [props.spaceUser.role, setValue])

  const onSubmit = async (value: SpaceRoleSwitchForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.PUT("/api/v2/spaces/{space_key}/users/{user_id}/role", {
        params: {
          path: { space_key: props.spaceUser.space_key, user_id: props.spaceUser.id },
        },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: value,
      })
      if (res.data == null) {
        toast.add({ type: "danger", title: "ロール変更", message: JSON.stringify(res.error) })
      } else {
        toast.add({ type: "success", title: "ロール変更", message: `${value.role} に変更しました` })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "ロール変更", message: e.message })
      throw e
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col p-0">
          <select className="form-select mb-2" {...register("role")}>
            <option value="owner">owner</option>
            <option value="moderator">moderator</option>
            <option value="member">member</option>
          </select>
        </div>
        {props.spaceUser.role !== watch('role') &&
          <div className="col p-0">
            <button type="submit" className="btn btn-primary" disabled={formState.isSubmitting || !formState.isValid}>
              update
            </button>
          </div>
        }
      </div>
    </form>
  )
}
